export const informationSourceData = [
    { key: "RRB Group D", value: "https://www.rrbcdg.gov.in/" },
    { key: "SSC CHSL", value: "https://ssc.nic.in/" },
    { key: "SSC MTS", value: "https://ssc.nic.in/" },
    { key: "SSC Stenographer", value: "https://ssc.nic.in/" },
    { key: "PNRD Assam", value: "https://pnrd.assam.gov.in/" },
    { key: "PSPCL LDC", value: "https://pspcl.in/" },
    { key: "UPPSC BEO", value: "https://uppsc.up.nic.in/" },
    { key: "CTET", value: "https://ctet.nic.in/" },
    { key: "TREIRB", value: "https://treirb.telangana.gov.in/" },
    { key: "UGC NET", value: "https://ugcnet.nta.nic.in/" },
    {
      key: "Current Affairs",
      value: "https://www.mha.gov.in/en/current-affairs",
    },
    { key: "NLC Graduate Executive Trainee", value: "https://www.nlcindia.in/" },
    { key: "Haryana Patwari", value: "https://hssc.gov.in/" },
    {
      key: "Bank of Maharashtra Clerk",
      value: "https://www.bankofmaharashtra.in/",
    },
    { key: "EPFO Assistant", value: "https://www.epfindia.gov.in/" },
    { key: "EPFO SSA", value: "https://www.epfindia.gov.in/" },
    { key: "IBPS Clerk", value: "https://www.ibps.in/" },
    { key: "Bank of Baroda Clerk", value: "https://www.bankofbaroda.in/" },
    { key: "Federal Bank Clerk", value: "https://www.federalbank.co.in/" },
    { key: "IDBI Executive", value: "https://www.idbi.com/" },
    { key: "RRB Office Assistant", value: "https://www.rrbcdg.gov.in/" },
    { key: "SBI Clerk", value: "https://www.sbi.co.in/" },
    { key: "South Indian Bank Clerk", value: "https://www.southindianbank.com/" },
    { key: "Bank of Maharastra PO", value: "https://www.bankofmaharashtra.in/" },
    { key: "Canara Bank PO", value: "https://www.canarabank.com/" },
    { key: "Federal Bank PO", value: "https://www.federalbank.co.in/" },
    { key: "IBPS PO", value: "https://www.ibps.in/" },
    { key: "J&K Bank Clerk", value: "https://www.jkbank.com/" },
    { key: "SBI Apprentice", value: "https://www.sbi.co.in/" },
    { key: "Bank of Baroda PO", value: "https://www.bankofbaroda.in/" },
    { key: "Dena Bank PO", value: "https://www.bankofbaroda.in/" },
    { key: "IDBI Assistant Manager", value: "https://www.idbi.com/" },
    { key: "IPPB Officer Scale - I", value: "https://www.ippbonline.com/" },
    { key: "J&K Bank PO", value: "https://www.jkbank.com/" },
    { key: "SBI PO", value: "https://www.sbi.co.in/" },
    { key: "Indian Bank PO", value: "https://www.indianbank.in/" },
    { key: "RRB Officer Scale - I", value: "https://www.rrbcdg.gov.in/" },
    { key: "South Indian Bank PO", value: "https://www.southindianbank.com/" },
    {
      key: "Union Bank of India PO",
      value: "https://www.unionbankofindia.co.in/",
    },
    { key: "United Bank of India PO", value: "https://www.bankofbaroda.in/" },
    {
      key: "Agricultural Field Officer - Scale I",
      value: "https://www.ibps.in/",
    },
    { key: "HR Personnel Officer - Scale I", value: "https://www.ibps.in/" },
    { key: "IBPS SO", value: "https://www.ibps.in/" },
    {
      key: "Union Bank of India SO",
      value: "https://www.unionbankofindia.co.in/",
    },
    { key: "NABARD Grade A", value: "https://www.nabard.org/" },
    { key: "Airforce Group X", value: "https://indianairforce.nic.in/" },
    { key: "Syndicate Bank PO", value: "https://www.canarabank.com/" },
    { key: "IT Officer - Scale I", value: "https://www.ibps.in/" },
    { key: "Law Officer - Scale I", value: "https://www.ibps.in/" },
    { key: "Marketing Officer - Scale I", value: "https://www.ibps.in/" },
    { key: "Rajbhasha Adhikari - Scale I", value: "https://www.ibps.in/" },
    { key: "SBI SO", value: "https://www.sbi.co.in/" },
    { key: "SEBI Grade A", value: "https://www.sebi.gov.in/" },
    { key: "NABARD Development Assistant", value: "https://www.nabard.org/" },
    { key: "CDS", value: "https://upsc.gov.in/" },
    { key: "DRDO MTS", value: "https://www.drdo.gov.in/" },
    { key: "Navy MR Agniveer", value: "https://www.joinindiannavy.gov.in/" },
    { key: "Navy Tradesman Mate", value: "https://www.joinindiannavy.gov.in/" },
    { key: "IB ACIO", value: "https://www.mha.gov.in/" },
    { key: "AAI JE ATC", value: "https://www.aai.aero/" },
    { key: "AFCAT", value: "https://indianairforce.nic.in/" },
    { key: "Airforce Group Y", value: "https://indianairforce.nic.in/" },
    { key: "CISF Constable", value: "https://www.cisf.gov.in/" },
    { key: "Navy AA", value: "https://www.joinindiannavy.gov.in/" },
    { key: "Navy SSR Agniveer", value: "https://www.joinindiannavy.gov.in/" },
    {
      key: "APPSC Assistant Executive Engineer",
      value: "https://psc.ap.gov.in/",
    },
    { key: "BSNL TTA", value: "https://www.bsnl.co.in/" },
    { key: "DMRC Asst Programmer", value: "https://www.delhimetrorail.com/" },
    { key: "DMRC JE", value: "https://www.delhimetrorail.com/" },
    { key: "DMRC JE CE", value: "https://www.delhimetrorail.com/" },
    { key: "DMRC JE EC", value: "https://www.delhimetrorail.com/" },
    { key: "DMRC JE EE", value: "https://www.delhimetrorail.com/" },
    { key: "DMRC JE ME", value: "https://www.delhimetrorail.com/" },
    { key: "DMRC Maintainer", value: "https://www.delhimetrorail.com/" },
    { key: "NIC Scientist B", value: "https://www.nic.in/" },
    { key: "CIL MT CE", value: "https://www.coalindia.in/" },
    { key: "CIL MT EE", value: "https://www.coalindia.in/" },
    { key: "CIL MT ME", value: "https://www.coalindia.in/" },
    { key: "DRDO Technician A", value: "https://www.drdo.gov.in/" },
    { key: "ECIL CS", value: "https://www.ecil.co.in/" },
    { key: "ECIL EC", value: "https://www.ecil.co.in/" },
    { key: "ECIL EE", value: "https://www.ecil.co.in/" },
    { key: "ECIL ME", value: "https://www.ecil.co.in/" },
    { key: "GATE CE", value: "https://gate.iitk.ac.in/" },
    { key: "GATE CH", value: "https://gate.iitk.ac.in/" },
    { key: "GATE CS", value: "https://gate.iitk.ac.in/" },
    { key: "NIC Technical Assistant A", value: "https://www.nic.in/" },
    { key: "CIL MT CS", value: "https://www.coalindia.in/" },
    { key: "GATE EC", value: "https://gate.iitk.ac.in/" },
    { key: "GATE EE", value: "https://gate.iitk.ac.in/" },
    { key: "GATE IN", value: "https://gate.iitk.ac.in/" },
    { key: "GATE ME", value: "https://gate.iitk.ac.in/" },
    { key: "GATE PI", value: "https://gate.iitk.ac.in/" },
    { key: "HSSC JE", value: "https://hssc.gov.in/" },
    { key: "LIC Assistant Engineer", value: "https://www.licindia.in/" },
    { key: "UPMRC JE CE", value: "https://www.lmrcl.com/" },
    { key: "UPMRC JE EC", value: "https://www.lmrcl.com/" },
    { key: "UPMRC JE EE", value: "https://www.lmrcl.com/" },
    { key: "PSPCL JE", value: "https://pspcl.in/" },
    { key: "SSC JE CE", value: "https://ssc.nic.in/" },
    { key: "SSC JE ME", value: "https://ssc.nic.in/" },
    { key: "ISRO Scientist CS", value: "https://www.isro.gov.in/" },
    { key: "ISRO Scientist EC", value: "https://www.isro.gov.in/" },
    { key: "ISRO Scientist EE", value: "https://www.isro.gov.in/" },
    { key: "ISRO Scientist ME", value: "https://www.isro.gov.in/" },
    { key: "ISRO Technician B Fitter", value: "https://www.isro.gov.in/" },
    { key: "ISRO Technical Assistant", value: "https://www.isro.gov.in/" },
    { key: "ISRO Technician", value: "https://www.isro.gov.in/" },
    { key: "RSMSSB JE", value: "https://rsmssb.rajasthan.gov.in/" },
    { key: "SSC JE EE", value: "https://ssc.nic.in/" },
    { key: "UPPCL JE", value: "https://www.uppcl.org/" },
    { key: "Vizag Steel Junior Trainee", value: "https://www.vizagsteel.com/" },
    { key: "LIC ADO", value: "https://www.licindia.in/" },
    { key: "UPPCL Assistant Engineer", value: "https://www.uppcl.org/" },
    { key: "UPPCL Technician", value: "https://www.uppcl.org/" },
    {
      key: "Vizag Steel Management Trainee",
      value: "https://www.vizagsteel.com/",
    },
    { key: "LIC AAO", value: "https://www.licindia.in/" },
    { key: "LIC HFL", value: "https://www.lichousing.com/" },
    { key: "NIACL Assistant", value: "https://www.newindia.co.in/" },
    { key: "OICL AO", value: "https://www.orientalinsurance.org.in/" },
    { key: "UIIC AO", value: "https://www.uiic.co.in/" },
    { key: "CWC Junior Superintendent", value: "https://www.cwc.gov.in/" },
    { key: "DMRC CRA", value: "https://www.delhimetrorail.com/" },
    { key: "FCI Manager", value: "https://fci.gov.in/" },
    { key: "LIC Assistant", value: "https://www.licindia.in/" },
    { key: "NIACL AO", value: "https://www.newindia.co.in/" },
    { key: "UIIC Assistant", value: "https://www.uiic.co.in/" },
    { key: "FCI", value: "https://fci.gov.in/" },
    { key: "IB Security Assistant", value: "https://www.mha.gov.in/" },
    { key: "Rajasthan Police SI", value: "https://police.rajasthan.gov.in/" },
    { key: "UP Police Constable", value: "https://uppbpb.gov.in/" },
    { key: "UP Police Sub Inspector", value: "https://uppbpb.gov.in/" },
    { key: "RRB ALP", value: "https://www.rrbcdg.gov.in/" },
    { key: "RRB JE", value: "https://www.rrbcdg.gov.in/" },
    { key: "RRB JE CE", value: "https://www.rrbcdg.gov.in/" },
    { key: "RRB JE EC", value: "https://www.rrbcdg.gov.in/" },
    { key: "RRB JE EE", value: "https://www.rrbcdg.gov.in/" },
    { key: "RRB JE IT", value: "https://www.rrbcdg.gov.in/" },
    { key: "RRB JE ME", value: "https://www.rrbcdg.gov.in/" },
    { key: "RPF Constable", value: "https://www.indianrailways.gov.in/" },
    { key: "RPF SI", value: "https://www.indianrailways.gov.in/" },
    { key: "RRB NTPC", value: "https://www.rrbcdg.gov.in/" },
    { key: "SSC CGL", value: "https://ssc.nic.in/" },
    { key: "Delhi Forest Guard", value: "https://forest.delhi.gov.in/" },
    { key: "SSC JHT", value: "https://ssc.nic.in/" },
    { key: "SSC Selection Post", value: "https://ssc.nic.in/" },
    {
      key: "Rajasthan Police Constable",
      value: "https://police.rajasthan.gov.in/",
    },
    { key: "RPSF", value: "https://www.indianrailways.gov.in/" },
    { key: "SSC GD Constable", value: "https://ssc.nic.in/" },
    { key: "UPPCS", value: "https://uppsc.up.nic.in/" },
    { key: "CBSE Junior Assistant", value: "https://www.cbse.gov.in/" },
    { key: "SSC CPO", value: "https://ssc.nic.in/" },
    { key: "SSC Scientific Assistant", value: "https://ssc.nic.in/" },
    { key: "HSSC Group D", value: "https://hssc.gov.in/" },
    { key: "Rajasthan Patwari", value: "https://rajpanchayat.rajasthan.gov.in/" },
    { key: "CSIR NET", value: "https://csirnet.nta.nic.in/" },
    { key: "DSSSB PRT", value: "https://dsssb.delhi.gov.in/" },
    { key: "REET", value: "https://www.reetbser21.com/" },
    { key: "UPTET", value: "https://updeled.gov.in/" },
    { key: "KVS", value: "https://kvsangathan.nic.in/" },
    { key: "UPRVUNL AE", value: "https://uprvunl.org/" },
    { key: "CG TET", value: "https://cgbse.nic.in/" },
    { key: "NDA", value: "https://upsc.gov.in/" },
    { key: "UPPSC AE", value: "https://uppsc.up.nic.in/" },
    { key: "UPSC IES", value: "https://upsc.gov.in/" },
    { key: "DDA Patwari", value: "https://dda.gov.in/" },
    { key: "UPSC EPFO", value: "https://upsc.gov.in/" },
    { key: "UP Lekhpal", value: "https://uppsc.up.nic.in/" },
    { key: "UP Police Jail Warder", value: "https://uppbpb.gov.in/" },
    { key: "ISRO Scientist CE", value: "https://www.isro.gov.in/" },
    { key: "UPSC CAPF AC", value: "https://upsc.gov.in/" },
    { key: "AFCAT EKT", value: "https://afcat.cdac.in/" },
    { key: "LMRC AM", value: "https://www.lmrcl.com/" },
    { key: "APSC JE", value: "https://apscrecruitment.in/" },
    { key: "APSC Assistant Engineer", value: "https://apscrecruitment.in/" },
    { key: "BHEL Engineer Trainee", value: "https://www.bhel.com/" },
    { key: "NBE", value: "https://www.natboard.edu.in/" },
    { key: "NTPC Diploma Trainee", value: "https://www.ntpc.co.in/" },
    { key: "RCFL", value: "https://www.rcfltd.com/" },
    { key: "MPSC AE", value: "https://mpsc.gov.in/" },
    { key: "Northern Coalfields Limited", value: "https://www.nclcil.in/" },
    { key: "ISRO Scientific Assistant", value: "https://www.isro.gov.in/" },
    { key: "UPSC Civil Services", value: "https://upsc.gov.in/" },
    { key: "TANGEDCO Assistant Engineer", value: "https://www.tangedco.gov.in/" },
    { key: "DMRC Assistant Manager", value: "https://www.delhimetrorail.com/" },
    { key: "APPSC Polytechnic Lecturers", value: "https://psc.ap.gov.in/" },
    { key: "MPSC Motor Vehicle Inspector", value: "https://mpsc.gov.in/" },
    { key: "Nainital Bank PO", value: "https://www.nainitalbank.co.in/" },
    { key: "Nainital Bank Clerk", value: "https://www.nainitalbank.co.in/" },
    { key: "NHB Assistant Manager", value: "https://nhb.org.in/" },
    { key: "RPSC 2nd Grade", value: "https://rpsc.rajasthan.gov.in/" },
    { key: "KPSC JE", value: "https://kpsc.kar.nic.in/" },
    { key: "KPSC Assistant Engineer", value: "https://kpsc.kar.nic.in/" },
    { key: "AWES Army Public School", value: "https://www.awesindia.com/" },
    { key: "HTET TGT", value: "https://haryanatet.in/" },
    { key: "RRB Junior Translator", value: "https://www.rrbcdg.gov.in/" },
    { key: "RRB Junior Stenographer", value: "https://www.rrbcdg.gov.in/" },
    {
      key: "RRB Ministerial and Isolated Categories",
      value: "https://www.rrbcdg.gov.in/",
    },
    { key: "MH SET", value: "https://setexam.unipune.ac.in/" },
    { key: "NPCIL Plant Operator", value: "https://www.npcil.nic.in/" },
    { key: "CRPF SI", value: "https://crpf.gov.in/" },
    { key: "India post Postman", value: "https://www.indiapost.gov.in/" },
    { key: "MPSC State Service", value: "https://mpsc.gov.in/" },
    { key: "MP Police Constable", value: "https://mppolice.gov.in/" },
    { key: "UP TGT", value: "https://uppsc.up.nic.in/" },
    { key: "ISRO Draughtsman", value: "https://www.isro.gov.in/" },
    { key: "LIC HFL Assistant", value: "https://www.lichousing.com/" },
    { key: "NPCIL Scientific Assistant", value: "https://www.npcil.nic.in/" },
    { key: "HSSC JBT Teacher", value: "https://hssc.gov.in/" },
    { key: "HSSC Gram Sachiv", value: "https://hssc.gov.in/" },
    { key: "Haryana PGT", value: "https://hssc.gov.in/" },
    { key: "HSSC TGT", value: "https://hssc.gov.in/" },
    { key: "HSSC Clerk", value: "https://hssc.gov.in/" },
    { key: "KTET", value: "https://ktet.kerala.gov.in/" },
    { key: "Canara Bank SO", value: "https://www.canarabank.com/" },
    { key: "DSSSB Foot Constable", value: "https://dsssb.delhi.gov.in/" },
    { key: "RPSC Lecturer Tech Edu", value: "https://rpsc.rajasthan.gov.in/" },
    { key: "UPPSC Assistant Professor", value: "https://uppsc.up.nic.in/" },
    { key: "UPPSC Lecturer", value: "https://uppsc.up.nic.in/" },
    { key: "PSSSB Driver", value: "https://sssb.punjab.gov.in/" },
    { key: "Maharashtra Police Constable", value: "https://mahapolice.gov.in/" },
    { key: "PPSC JE", value: "https://ppsc.gov.in/" },
    { key: "TRB Tripura Teacher", value: "https://trb.tripura.gov.in/" },
    { key: "Tripura TET", value: "https://trb.tripura.gov.in/" },
    { key: "OSSSC Nursing Officer", value: "https://osssc.gov.in/" },
    { key: "ICMR Assistant", value: "https://www.icmr.gov.in/" },
    { key: "AEGCL Assistant Manager", value: "https://www.aegcl.co.in/" },
    { key: "Tripura LDC", value: "https://trb.tripura.gov.in/" },
    { key: "AAI JE Airport Operations", value: "https://www.aai.aero/" },
    { key: "AAI JE Technical", value: "https://www.aai.aero/" },
    { key: "JKSSB SI Commercial Taxes", value: "https://jkssb.nic.in/" },
    { key: "JKSSB Assistant Compiler", value: "https://jkssb.nic.in/" },
    { key: "JKSSB Depot Assistant", value: "https://jkssb.nic.in/" },
    { key: "JKSSB className 4", value: "https://jkssb.nic.in/" },
    { key: "DSSSB Pharmacist", value: "https://dsssb.delhi.gov.in/" },
    { key: "HPPSC Clerk", value: "https://hppsc.hp.gov.in/" },
    { key: "PSSSB Clerk", value: "https://sssb.punjab.gov.in/" },
    {
      key: "EXIM Bank Management Trainee",
      value: "https://www.eximbankindia.in/",
    },
    { key: "CGPSC AE", value: "https://psc.cg.gov.in/" },
    { key: "RPSC RAS", value: "https://rpsc.rajasthan.gov.in/" },
    { key: "Telangana Police Constable", value: "https://www.tslprb.in/" },
    { key: "Telangana Police SI", value: "https://www.tslprb.in/" },
    { key: "UBTER Staff Nurse", value: "https://ubter.in/" },
    { key: "DSSSB SI", value: "https://dsssb.delhi.gov.in/" },
    { key: "BARC Stipendiary Trainee", value: "https://www.barc.gov.in/" },
    { key: "Haryana Civil Services", value: "https://hssc.gov.in/" },
    { key: "DHS Assam Grade 4", value: "https://dhs.assam.gov.in/" },
    { key: "Allahabad HC UP HJS", value: "https://www.allahabadhighcourt.in/" },
    { key: "Kerala SET", value: "https://lbscentre.kerala.gov.in/" },
    { key: "ARS Exam", value: "https://www.icar.org.in/" },
    { key: "PPSC Naib Tehsildar", value: "https://ppsc.gov.in/" },
    { key: "NFL MT", value: "https://www.nationalfertilizers.com/" },
    { key: "IDBI SO", value: "https://www.idbi.com/" },
    { key: "MDL Trade Apprentice", value: "https://www.mazagondock.in/" },
    {
      key: "NFL Assistant Accountant",
      value: "https://www.nationalfertilizers.com/",
    },
    { key: "NPS Trust", value: "https://npstrust.org.in/" },
    { key: "HSSC SI", value: "https://hssc.gov.in/" },
    { key: "JKSSB JE", value: "https://jkssb.nic.in/" },
    { key: "JKSSB Draftsman", value: "https://jkssb.nic.in/" },
    { key: "JKSSB Supervisor", value: "https://jkssb.nic.in/" },
    { key: "JKSSB Junior Assistant", value: "https://jkssb.nic.in/" },
    { key: "JPSC AE", value: "https://jpsc.gov.in/" },
    { key: "RSMSSB Forest Guard", value: "https://rsmssb.rajasthan.gov.in/" },
    { key: "OSSC Staff Nurse", value: "https://osssc.gov.in/" },
    { key: "Odisha Police Constable", value: "https://odishapolice.gov.in/" },
    { key: "OSSC Laboratory Assistant", value: "https://osssc.gov.in/" },
    { key: "ECGC PO", value: "https://www.ecgc.in/" },
    { key: "OSSSC Pharmacist", value: "https://osssc.gov.in/" },
    { key: "OSSSC Radiographer", value: "https://osssc.gov.in/" },
    { key: "UPPSC Agriculture Service", value: "https://uppsc.up.nic.in/" },
    { key: "HSSC Haryana Police Constable", value: "https://hssc.gov.in/" },
    { key: "JKSSB Driver", value: "https://jkssb.nic.in/" },
    { key: "CISF ASI", value: "https://cisf.gov.in/" },
    {
      key: "Rajasthan High Court District Judge",
      value: "https://hcraj.nic.in/",
    },
    {
      key: "Calcutta High Court DEO",
      value: "https://calcuttahighcourt.gov.in/",
    },
    { key: "Calcutta High Court", value: "https://calcuttahighcourt.gov.in/" },
    { key: "JPSC Assistant Professor", value: "https://jpsc.gov.in/" },
    { key: "IRDAI Assistant Manager", value: "https://www.irdai.gov.in/" },
    {
      key: "Patna High Court Personal Assistant",
      value: "https://patnahighcourt.gov.in/",
    },
    { key: "CG Police Constable", value: "https://cgpolice.gov.in/" },
    {
      key: "Saraswat Bank Junior Officer",
      value: "https://www.saraswatbank.com/",
    },
    { key: "Rajasthan High Court Clerk", value: "https://hcraj.nic.in/" },
    { key: "OSSC Junior Accountant", value: "https://osssc.gov.in/" },
    {
      key: "OSSC Assistant Commercial Tax Officer (ACTO)",
      value: "https://osssc.gov.in/",
    },
    { key: "JKPSC Combined Competitive Exam", value: "https://jkpsc.nic.in/" },
    { key: "DBT JRF", value: "https://dbtindia.gov.in/" },
    { key: "PSSSB Stenographer", value: "https://sssb.punjab.gov.in/" },
    { key: "PSSSB Excise Inspector", value: "https://sssb.punjab.gov.in/" },
    { key: "PSSSB Food Safety Officer", value: "https://sssb.punjab.gov.in/" },
    { key: "UPSSSC ITI Instructor", value: "https://upsssc.gov.in/" },
    { key: "UPSSSC Forest Guard", value: "https://upsssc.gov.in/" },
    { key: "UPSSSC Combined Technical Service", value: "https://upsssc.gov.in/" },
    { key: "UPSSSC VDO", value: "https://upsssc.gov.in/" },
    { key: "HP Forest Guard", value: "https://hp.gov.in/" },
    {
      key: "Allahabad High Court RO",
      value: "https://www.allahabadhighcourt.in/",
    },
    { key: "BARC DAE", value: "https://www.barc.gov.in/" },
    {
      key: "Delhi High Court Personal Assistant",
      value: "https://delhihighcourt.nic.in/",
    },
    { key: "PSSSB Junior Draftsman", value: "https://sssb.punjab.gov.in/" },
    { key: "BSPHCL Junior Lineman", value: "https://www.bsphcl.co.in/" },
    { key: "BSPHCL Assistant Operator", value: "https://www.bsphcl.co.in/" },
    { key: "India Government Mint", value: "https://www.spmcil.com/" },
    { key: "UPSSSC PET", value: "https://upsssc.gov.in/" },
    {
      key: "HPCL Asst. Maintenance Technician",
      value: "https://www.hindustanpetroleum.com/",
    },
    { key: "Supreme Court Law Clerk", value: "https://www.sci.gov.in/" },
    { key: "ASRB NET", value: "https://asrb.org.in/" },
    { key: "OSSC Food Safety Officer", value: "https://ossc.gov.in/" },
    { key: "OSSC Weaving Supervisor", value: "https://ossc.gov.in/" },
    { key: "MP Police SI", value: "https://mppolice.gov.in/" },
    { key: "WB Police Constable", value: "https://wbpolice.gov.in/" },
    { key: "WB Police SI", value: "https://wbpolice.gov.in/" },
    { key: "APSC Inspector Of Statistics", value: "https://apsc.nic.in/" },
    { key: "UKSSSC Forest Guard", value: "https://sssc.uk.gov.in/" },
    { key: "UPSC Data Processing Assistant", value: "https://upsc.gov.in/" },
    { key: "JKPSC KAS", value: "https://jkpsc.nic.in/" },
    { key: "BSPHCL Technician", value: "https://www.bsphcl.co.in/" },
    { key: "OSSC Ayush Assistant", value: "https://ossc.gov.in/" },
    { key: "AAI Junior Executive", value: "https://www.aai.aero/" },
    { key: "AIIMS Nursing Officer", value: "https://www.aiims.edu/" },
    {
      key: "Allahabad High Court Law Clerk",
      value: "https://www.allahabadhighcourt.in/",
    },
    { key: "APPSC AE", value: "https://psc.ap.gov.in/" },
    { key: "APPSC ASO", value: "https://psc.ap.gov.in/" },
    { key: "APPSC Assistant Professor", value: "https://psc.ap.gov.in/" },
    { key: "APPSC Deputy Surveyor", value: "https://psc.ap.gov.in/" },
    { key: "APPSC Divisional Accounts Officer", value: "https://psc.ap.gov.in/" },
    { key: "APPSC Forest Beat Officer", value: "https://psc.ap.gov.in/" },
    { key: "APPSC Forest Range Officer", value: "https://psc.ap.gov.in/" },
    { key: "APPSC Grama Sachivalayam", value: "https://psc.ap.gov.in/" },
    { key: "APPSC Group 2", value: "https://psc.ap.gov.in/" },
    { key: "APPSC Royalty Inspector", value: "https://psc.ap.gov.in/" },
    { key: "APPSC Sericulture Officer", value: "https://psc.ap.gov.in/" },
    { key: "APPSC Town Planning", value: "https://psc.ap.gov.in/" },
    { key: "APPSC VRO", value: "https://psc.ap.gov.in/" },
    { key: "APPSC Welfare Organizer", value: "https://psc.ap.gov.in/" },
    {
      key: "RSMSSB",
      value: "https://rsmssb.rajasthan.gov.in/page?menuName=Home",
    },
    {
      key: "RSMSSB Asst. Radiographer",
      value: "https://rsmssb.rajasthan.gov.in/page?menuName=Home",
    },
    {
      key: "RSMSSB ECG Technician",
      value: "https://rsmssb.rajasthan.gov.in/page?menuName=Home",
    },
    {
      key: "RSMSSB Junior Instructor",
      value: "https://rsmssb.rajasthan.gov.in/page?menuName=Home",
    },
    {
      key: "RSMSSB Lab Assistant",
      value: "https://rsmssb.rajasthan.gov.in/page?menuName=Home",
    },
    {
      key: "RSMSSB Lab Technician",
      value: "https://rsmssb.rajasthan.gov.in/page?menuName=Home",
    },
    {
      key: "RSMSSB LDC",
      value: "https://rsmssb.rajasthan.gov.in/page?menuName=Home",
    },
    {
      key: "RSMSSB Librarian",
      value: "https://rsmssb.rajasthan.gov.in/page?menuName=Home",
    },
    {
      key: "RSMSSB Mahila Supervisor",
      value: "https://rsmssb.rajasthan.gov.in/page?menuName=Home",
    },
    {
      key: "RSMSSB Stenographer",
      value: "https://rsmssb.rajasthan.gov.in/page?menuName=Home",
    },
    {
      key: "Arunachal Pradesh PSC",
      value: "https://appsc.gov.in/Index/institute_home/ins/RECINS001",
    },
    {
      key: "Arunachal Pradesh PSC ASO",
      value: "https://appsc.gov.in/Index/institute_home/ins/RECINS001",
    },
    {
      key: "Arunachal Pradesh PSC GDMO",
      value: "https://appsc.gov.in/Index/institute_home/ins/RECINS001",
    },
    {
      key: "BPSC Assistant Conservator of Forest",
      value: "https://bpsc.bihar.gov.in/",
    },
    {
      key: "BPSC Assistant Prosecution Officer",
      value: "https://bpsc.bihar.gov.in/",
    },
    { key: "BPSC Judicial Services", value: "https://bpsc.bihar.gov.in/" },
    { key: "BPSC MDO", value: "https://bpsc.bihar.gov.in/" },
    { key: "BPSC Motor Vehicle Inspector", value: "https://bpsc.bihar.gov.in/" },
    { key: "BPSC Project Manager", value: "https://bpsc.bihar.gov.in/" },
    { key: "CRPF", value: "https://crpf.gov.in/" },
    { key: "CRPF Constable", value: "https://crpf.gov.in/" },
    { key: "CRPF Head Constable", value: "https://crpf.gov.in/" },
    { key: "CRPF Paramedical Staff", value: "https://crpf.gov.in/" },
    { key: "GPSC Assistant Engineer", value: "https://gpsc.gujarat.gov.in/" },
    { key: "GPSC DYSO", value: "https://gpsc.gujarat.gov.in/" },
    { key: "GPSC Police Inspector", value: "https://gpsc.gujarat.gov.in/" },
    { key: "GPSC State Tax Inspector", value: "https://gpsc.gujarat.gov.in/" },
    { key: "Indian Coast Guard", value: "https://joinindiancoastguard.cdac.in/" },
    {
      key: "Indian Coast Guard Assistant Commandant",
      value: "https://joinindiancoastguard.cdac.in/",
    },
    {
      key: "Indian Coast Guard Navik DB",
      value: "https://joinindiancoastguard.cdac.in/",
    },
    {
      key: "Indian Coast Guard Yantrik",
      value: "https://joinindiancoastguard.cdac.in/",
    },
    { key: "JSSC", value: "https://jssc.nic.in/" },
    { key: "JSSC ANM", value: "https://jssc.nic.in/" },
    { key: "JSSC CGL", value: "https://jssc.nic.in/" },
    { key: "JSSC Driver", value: "https://jssc.nic.in/" },
    { key: "JSSC Excise Constable", value: "https://jssc.nic.in/" },
    { key: "JSSC IRB", value: "https://jssc.nic.in/" },
    { key: "JSSC JE", value: "https://jssc.nic.in/" },
    { key: "JSSC panchayat secretary", value: "https://jssc.nic.in/" },
    { key: "JSSC PGT", value: "https://jssc.nic.in/" },
    { key: "JSSC SI", value: "https://jssc.nic.in/" },
    { key: "JSSC Special Branch Constable", value: "https://jssc.nic.in/" },
    { key: "JSSC TGT", value: "https://jssc.nic.in/" },
    { key: "KPSC", value: "https://kpsc.kar.nic.in/" },
    { key: "KPSC FDS SDA", value: "https://kpsc.kar.nic.in/" },
    { key: "KPSC Group C", value: "https://kpsc.kar.nic.in/" },
    { key: "KPSC JTO", value: "https://kpsc.kar.nic.in/" },
    { key: "KPSC KAS", value: "https://kpsc.kar.nic.in/" },
    { key: "KPSC Staff Nurse", value: "https://kpsc.kar.nic.in/" },
    { key: "CGPSC", value: "https://psc.cg.gov.in/" },
    { key: "CGPSC Civil Judge", value: "https://psc.cg.gov.in/" },
    { key: "CGPSC CMO", value: "https://psc.cg.gov.in/" },
    { key: "CGPSC Forest Ranger", value: "https://psc.cg.gov.in/" },
    { key: "CGPSC Forest Service", value: "https://psc.cg.gov.in/" },
    { key: "CGPSC Medical Officer", value: "https://psc.cg.gov.in/" },
    {
      key: "CGPSC Veterinary Assistant Surgeon",
      value: "https://psc.cg.gov.in/",
    },
    { key: "WBPSC", value: "https://psc.wb.gov.in/" },
    { key: "WBPSC Assistant Engineer", value: "https://psc.wb.gov.in/" },
    { key: "WBPSC Assistant Professor", value: "https://psc.wb.gov.in/" },
    { key: "WBPSC Fire operator", value: "https://psc.wb.gov.in/" },
    { key: "WBPSC Food SI", value: "https://psc.wb.gov.in/" },
    { key: "WBPSC ICDS", value: "https://psc.wb.gov.in/" },
    { key: "WBPSC IDO", value: "https://psc.wb.gov.in/" },
    { key: "WBPSC JE", value: "https://psc.wb.gov.in/" },
    { key: "WBPSC MVI", value: "https://psc.wb.gov.in/" },
    { key: "BSF", value: "https://rectt.bsf.gov.in/" },
    { key: "BSF Constable", value: "https://rectt.bsf.gov.in/" },
    { key: "BSF Driver", value: "https://rectt.bsf.gov.in/" },
    { key: "BSF Head Constable", value: "https://rectt.bsf.gov.in/" },
    { key: "BSF SI", value: "https://rectt.bsf.gov.in/" },
    { key: "BSF Tradesman", value: "https://rectt.bsf.gov.in/" },
    { key: "RPSC 1st Grade", value: "https://rpsc.rajasthan.gov.in/" },
    { key: "RPSC AAO", value: "https://rpsc.rajasthan.gov.in/" },
    { key: "RPSC ACF", value: "https://rpsc.rajasthan.gov.in/" },
    { key: "RPSC AEN", value: "https://rpsc.rajasthan.gov.in/" },
    { key: "RPSC ASO", value: "https://rpsc.rajasthan.gov.in/" },
    { key: "RPSC Food Safety Officer", value: "https://rpsc.rajasthan.gov.in/" },
    { key: "RPSC HM", value: "https://rpsc.rajasthan.gov.in/" },
    { key: "RPSC Junior Accountant", value: "https://rpsc.rajasthan.gov.in/" },
    { key: "RPSC LDC", value: "https://rpsc.rajasthan.gov.in/" },
    { key: "RPSC School Lecturer", value: "https://rpsc.rajasthan.gov.in/" },
    { key: "RPSC SSO", value: "https://rpsc.rajasthan.gov.in/" },
    { key: "Assam Police", value: "https://slprbassam.in/" },
    { key: "Assam Police Constable", value: "https://slprbassam.in/" },
    { key: "Assam Police Forest Guard", value: "https://slprbassam.in/" },
    { key: "Assam Police Transport Department", value: "https://slprbassam.in/" },
    { key: "Kerala PSC", value: "https://thulasi.psc.kerala.gov.in/thulasi/" },
    {
      key: "Kerala PSC Assistant Professor",
      value: "https://thulasi.psc.kerala.gov.in/thulasi/",
    },
    {
      key: "Kerala PSC Assistant Surgeon",
      value: "https://thulasi.psc.kerala.gov.in/thulasi/",
    },
    {
      key: "Kerala PSC Fireman",
      value: "https://thulasi.psc.kerala.gov.in/thulasi/",
    },
    {
      key: "Kerala PSC food safety officer",
      value: "https://thulasi.psc.kerala.gov.in/thulasi/",
    },
    {
      key: "Kerala PSC LDC",
      value: "https://thulasi.psc.kerala.gov.in/thulasi/",
    },
    {
      key: "Kerala PSC Staff Nurse",
      value: "https://thulasi.psc.kerala.gov.in/thulasi/",
    },
    {
      key: "Kerala PSC VEO",
      value: "https://thulasi.psc.kerala.gov.in/thulasi/",
    },
    { key: "JVVNL", value: "https://www.bijlimitra.com/custumerLoginPage" },
    {
      key: "JVVNL Accountant",
      value: "https://www.bijlimitra.com/custumerLoginPage",
    },
    {
      key: "JVVNL Helper 2",
      value: "https://www.bijlimitra.com/custumerLoginPage",
    },
    { key: "JVVNL JEN", value: "https://www.bijlimitra.com/custumerLoginPage" },
    {
      key: "JVVNL Technical Helper",
      value: "https://www.bijlimitra.com/custumerLoginPage",
    },
    { key: "CISF", value: "https://www.cisf.gov.in/" },
    { key: "CISF Driver", value: "https://www.cisf.gov.in/" },
    { key: "CISF Tradesman", value: "https://www.cisf.gov.in/" },
    { key: "OPSC", value: "https://www.opsc.gov.in/Public/OPSC/Default.aspx" },
    {
      key: "OPSC ACF Forest Ranger",
      value: "https://www.opsc.gov.in/Public/OPSC/Default.aspx",
    },
    {
      key: "OPSC AEE",
      value: "https://www.opsc.gov.in/Public/OPSC/Default.aspx",
    },
    {
      key: "OPSC ASO",
      value: "https://www.opsc.gov.in/Public/OPSC/Default.aspx",
    },
    {
      key: "OPSC Assistant Fisheries Officer",
      value: "https://www.opsc.gov.in/Public/OPSC/Default.aspx",
    },
    {
      key: "OPSC IMO",
      value: "https://www.opsc.gov.in/Public/OPSC/Default.aspx",
    },
    {
      key: "OPSC Lecturer",
      value: "https://www.opsc.gov.in/Public/OPSC/Default.aspx",
    },
    {
      key: "OPSC Medical Officer",
      value: "https://www.opsc.gov.in/Public/OPSC/Default.aspx",
    },
    {
      key: "OPSC OAS",
      value: "https://www.opsc.gov.in/Public/OPSC/Default.aspx",
    },
    {
      key: "OPSC OMAS",
      value: "https://www.opsc.gov.in/Public/OPSC/Default.aspx",
    },
    {
      key: "OSSC Assistant Scientific Officer",
      value: "https://www.ossc.gov.in/Public/OSSC/Default.aspx",
    },
    {
      key: "OSSC CPSE",
      value: "https://www.ossc.gov.in/Public/OSSC/Default.aspx",
    },
    {
      key: "OSSC Excise SI",
      value: "https://www.ossc.gov.in/Public/OSSC/Default.aspx",
    },
    {
      key: "OSSC Industries Promotion Officer",
      value: "https://www.ossc.gov.in/Public/OSSC/Default.aspx",
    },
    { key: "OSSC JE", value: "https://www.ossc.gov.in/Public/OSSC/Default.aspx" },
    {
      key: "OSSC Soil Conservation Extension Worker",
      value: "https://www.ossc.gov.in/Public/OSSC/Default.aspx",
    },
  ];  